// defining a constant
export const typesFSCPAGE = {
    GET_FSCPAGE_DATA_SUCCESS: 'GET_FSCPAGE_DATA_SUCCESS',
    GET_FSCPAGE_DATA_ERROR: 'GET_FSCPAGE_DATA_ERROR',
    GET_FSCPAGE_DATA_BEGIN: 'GET_FSCPAGE_DATA_BEGIN'
}

